import React from "react";
import "../styles/Navbar.css";
import { Link } from 'react-scroll';

function Navbar() {
    return (
        <nav className="navbar sticky-top justify-content-center">
            <Link
                activeClass="active"
                to="about"
                spy={true}
                smooth={true}
                offset={-60}
                duration={800}
            >ABOUT</Link>
            <Link
                activeClass="active"
                to="resume"
                spy={true}
                smooth={true}
                offset={-60}
                duration={800}
            >RESUME</Link>
            <Link
                activeClass="active"
                to="portfolio"
                spy={true}
                smooth={true}
                offset={-110}
                duration={800}
            >PORTFOLIO</Link>
            <Link
                activeClass="active"
                to="contact"
                spy={true}
                smooth={true}
                offset={-60}
                duration={800}
            >CONTACT</Link>
        </nav>
    )
};

export default Navbar;